import React from "react";
import { MessageCircle } from "lucide-react";

import { Button } from "./ui/button";
import { whatsappUrl } from "../config/contact";

export default function FloatingActionButtonSize() {
  return (
    <a
      href={whatsappUrl()}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-4 z-30"
    >
      <Button
        size="icon"
        className="h-14 w-14 rounded-full bg-emerald-500 shadow-2xl transition hover:bg-emerald-400"
      >
        <MessageCircle className="h-8 w-8 text-white" />
      </Button>
    </a>
  );
}
